import ga4 from "@/lib/tracking/ga4Core";

const AD_PAGE_JOURNEY = "residential_indicator_from_ad_page";
const SERVICES_JOURNEY = "residential_indicator_from_services";

export const trackViewResidentialIndicatorsBanner = ({
  listingType,
  category,
  source = decodeURI(document?.referrer),
}) => {
  const eventName = "view_event";
  const eventParams = {
    journey_details: AD_PAGE_JOURNEY,
    listing_type: listingType,
    property_category: category,
    source,
    target: "residential_indicator_viewed",
  };

  ga4.trackUserInteraction(eventName, eventParams);
};

export const trackClickResidentialIndicatorsBanner = ({
  listingType,
  category,
  source = decodeURI(document?.referrer),
}) => {
  const eventName = "click_interaction";
  const eventParams = {
    journey_details: AD_PAGE_JOURNEY,
    listing_type: listingType,
    property_category: category,
    source,
    target: "residential_indicator_clicked",
  };

  ga4.trackUserInteraction(eventName, eventParams);
};

export const trackClickResidentialIndicatorPeriod = ({
  listingType,
  category,
  source = decodeURI(document?.referrer),
  journey = "services",
}) => {
  const eventName = "click_interaction";
  const eventParams = {
    journey_details: journey === "pdp" ? AD_PAGE_JOURNEY : SERVICES_JOURNEY,
    listing_type: listingType,
    property_category: category,
    source,
    target: "show_average_price_period",
  };

  ga4.trackUserInteraction(eventName, eventParams);
};

export const trackClickResidentialIndicatorAqarPlus = ({
  listingType,
  category,
  source = decodeURI(document?.referrer),
  journey = "services",
}) => {
  const eventName = "click_interaction";
  const eventParams = {
    journey_details: journey === "pdp" ? AD_PAGE_JOURNEY : SERVICES_JOURNEY,
    listing_type: listingType,
    property_category: category,
    source,
    target: "explore_aqar_plus_features",
  };

  ga4.trackUserInteraction(eventName, eventParams);
};

export const trackClickResidentialIndicatorEdit = ({
  listingType,
  category,
  source = decodeURI(document?.referrer),
  journey = "services",
}) => {
  const eventName = "click_interaction";
  const eventParams = {
    journey_details: journey === "pdp" ? AD_PAGE_JOURNEY : SERVICES_JOURNEY,
    listing_type: listingType,
    property_category: category,
    source,
    target: "explore_aqar_plus_features",
  };

  ga4.trackUserInteraction(eventName, eventParams);
};

export const trackClickResidentialIndicatorShowChart = ({
  listingType,
  category,
  source = decodeURI(document?.referrer),
  journey = "services",
}) => {
  const eventName = "click_interaction";
  const eventParams = {
    journey_details: journey === "pdp" ? AD_PAGE_JOURNEY : SERVICES_JOURNEY,
    listing_type: listingType,
    property_category: category,
    source,
    target: "residential_indicator_from_ad_page",
  };

  ga4.trackUserInteraction(eventName, eventParams);
};
